import axios from "axios";
import authHeader from "utils/auth-header";

export interface PayloadObject {
  id: number;
  object_type:
    | "movie"
    | "tv_series"
    | "live_tv"
    | "podcast"
    | "podcast_episode"
    | "radio"
    | "song"
    | "ppv"
    | "video"
    | "playlist"
    | "publication_video";
  is_favourite: boolean;
}

export interface ArtistPayload {
  id: number;
  user_type: "artist" | "user";
  is_follow: boolean;
}

export const favoriteAssest = async (data: PayloadObject) => {
  const response = await axios({
    method: "post",
    data: data,
    url: `${process.env.REACT_APP_BACKEND_SERVER}/v2/favourites`,
    headers: authHeader(),
  });

  return response;
};

export const followArtist = async (data: ArtistPayload) => {
  const response = await axios({
    method: "post",
    data: data,
    url: `${process.env.REACT_APP_BACKEND_SERVER}/v2/follow`,
    headers: authHeader(),
  });

  return response;
};

export const CheckingFollowingStatus = async (
  followId: number,
  user_type: "artist" | "user",
) => {
  const response = await axios({
    method: "get",
    url: `${process.env.REACT_APP_BACKEND_SERVER}/v2/follow/check-followings?following_id=${followId}&user_type=${user_type}`,
    headers: authHeader(),
  });

  return response?.data;
};
